module.exports = __webpack_public_path__ + "6c4a0dbc/img/settings-icon.121d9519.svg";